export default "__VITE_ASSET__c1ce45e1__"